let sky={

}

let install=(vue)=>{
    vue.prototype.$Sky =sky;
}

let add=(name,obj)=>{
    if(sky[name])
    {
        throw Error(`已经有名为:${name}参数了`);
    }
    sky[name]=obj;
}

let get=()=>{
    return sky;
}

module.exports={
    install,
    add,
    get,
}


// WEBPACK FOOTER //
// ./src/common/sky-extends.js